import React, { useState, useEffect } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { DropdownArrowHoc } from '../../../assets/images';
import { isLocalUser, getUserNickName, getContactNameFromRoster, getDataFromRoster, formatUserIdToJid } from '../../../Helpers/Chat/User';
import UserStatus from '../Common/UserStatus';
import { getFormatPhoneNumber } from '../../../Helpers/Utility';
import ProfileImage from '../../Common/ProfileImage';
import { getFromLocalStorageAndDecrypt } from '../../../Helpers/Chat/webChatEncryptDecrypt';
import { store } from '../../../Redux/store';
import { showModal } from '../../../Redux/feature/popUpDataSlice';
import { useSelector } from 'react-redux';

const Participants = (props) => {
    const { isAdmin,groupuniqueId, members: { GroupUser, userId: fromuser,thumbImage, username, userId, emailId, status, statusMsg, userType } = {} } = props
    const displayName = isLocalUser(userId) ? "You" : getContactNameFromRoster(getDataFromRoster(userId)) || getFormatPhoneNumber(userId);
    const [menuDropDownStatus, setmenuDropDownStatus] = useState(false)
    const storeData = useSelector((state) => state);
    const { vCardData, rosterData } = storeData
    const [ getImage, setImage ] = React.useState('')

    useEffect(() => {
        if(!isAdmin){
            setmenuDropDownStatus(false);
        }
    }, [isAdmin])

    React.useEffect(() => {
        if(rosterData){
            rosterData.data.map((img)=>{
                if(userId === img.userId) return setImage(img.image)
            })
        }

        if(userId === vCardData.data.userId){
            return setImage(vCardData.data.image)
        }
    }, [rosterData,props])

    const updateJid = userId || username || GroupUser;
    const handleMenuDrop = () => {
        if (isAdmin)
            setmenuDropDownStatus(!menuDropDownStatus)
    }
    const makeAdmin = () => {
        const userjid = formatUserIdToJid(updateJid);
        store.dispatch(showModal({
            groupuniqueId,
            userjid,
            displayName,
            open: true,
            modelType: 'action',
            title: 'Make '+displayName+' an admin for this group?',
            activeclass: 'make-admin',
            action: 'groupMakeAdmin'
        }))
        setmenuDropDownStatus(false)
    }
    const removeUser = () => {
        const userjid = formatUserIdToJid(updateJid);
        const checkAdmin = (userType === 'o') ? 1 : 0
        setmenuDropDownStatus(false)
        store.dispatch(showModal({
            groupuniqueId,
            userjid,
            displayName,
            checkAdmin,
            open: true,
            title: 'Remove '+displayName+' from this group?',
            activeclass: 'remove-participant',
            modelType: 'action',
            action: 'groupRemoveMember'
        }))
    }
    const updateStatus = status || statusMsg || ''
    const localUser = isLocalUser(fromuser)
    const nickName = getUserNickName(props.members);
    const token = getFromLocalStorageAndDecrypt('token');

    const getInitalName = () => {
        if (localUser) return nickName;
        // else if (displayNickname) return "";
        else return displayName;
    }

    return (
        <li>
            <OutsideClickHandler onOutsideClick={() => {
                if (menuDropDownStatus) {
                    handleMenuDrop()
                }
                }} >
                <div className="user-profile-name">
                    {
                        <ProfileImage
                            chatType={'chat'}
                            userToken={token}
                            temporary={false}
                            imageToken={thumbImage !== "" ? thumbImage : getImage}
                            emailId={emailId}
                            userId={updateJid}
                            name={getInitalName()}
                        />
                    }
                    <div className="profile-name">
                        <span>
                            <h4 className={!localUser ? 'participant' : ''}>{displayName}</h4>
                            {!localUser && isAdmin && <i className={(menuDropDownStatus) ? 'menu-icon open' : 'menu-icon'} onClick={handleMenuDrop}><DropdownArrowHoc /> </i>}
                        </span>
                        <h6 className="profile-status">
                            <UserStatus status={updateStatus} userId={updateJid} />
                            {userType === 'o' && <span className={'adminicon'}>Admin</span>}
                        </h6>
                        {menuDropDownStatus && !isLocalUser(updateJid) &&
                            <ul className="menu-dropdown">
                                {userType !== 'o' && <li onClick={makeAdmin}><span>Make admin</span></li>}
                                <li onClick={removeUser}><span>Remove from Group</span></li>
                            </ul>
                        }
                    </div>
                </div>
            </OutsideClickHandler>

        </li>
    );
};

export default Participants;
